'use client';

import { Modal } from '@1debit/chimekit';
import { Info } from '@1debit/icons';
import { useState } from 'react';
import Button from '../Buttons/BaseButton';
import { ContentfulRichTextBlock, Sys } from 'libs/contentful/props';
import RichTextCopy from '../RichTextCopy/RichTextCopy';

import { liveUpdateAttrs } from 'libs/contentful/utils';

export interface BaseModalProps {
  sys?: Sys;
  title: string;
  body: string | ContentfulRichTextBlock;
  openButtonText?: string;
}

const BaseModal = ({ title, body, openButtonText, sys }: BaseModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const mainText = typeof body === 'string' ? <p>{body}</p> : <RichTextCopy copy={body} />;

  return (
    <>
      <span className="inline-block align-middle">
        <button
          className="font-sans text-legal leading-[1.65] font-medium w-fit align-middle py-1 flex justify-center gap-[6px] cursor-pointer"
          onClick={() => setIsOpen(true)}
          {...liveUpdateAttrs(sys?.id, 'disclaimerText')}>
          <Info className="inline-block h-[18px] w-[18px]" />
          {openButtonText && <>{openButtonText} ›</>}
        </button>
      </span>
      <Modal analyticsId={null} open={isOpen} onOpenChange={setIsOpen}>
        <Modal.Content className="sm:pb-10 sm:pt-5 sm:px-[60px] box-content sm:rounded-[10px] data-[state=open]:translate-y-0 animate-modal-slide-in">
          <Modal.Body className="sm:px-0">
            <Modal.Title className="text-heading-md font-sans" {...liveUpdateAttrs(sys?.id, 'headline')}>
              {title}
            </Modal.Title>
            <div className="font-serif my-[10px] text-body-serif" {...liveUpdateAttrs(sys?.id, 'copy')}>
              {mainText}
            </div>
          </Modal.Body>
          <Modal.Footer className="sm:pb-0 sm:pl-0">
            <div className="sm:w-1/2 w-full ">
              <Button onClick={() => setIsOpen(false)} variant="outline" className="border border-kale">
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default BaseModal;
